import type { History, Location } from 'history';

export const updateTablePageQueryParams = (
  page: number,
  tableId: string,
  location?: Partial<Location>,
  history?: History,
) => {
  if (!location || !history) {
    return;
  }
  const searchParams = new URLSearchParams(location.search);
  const initialSearchParamsSize = searchParams.size;

  const pageValueForParam = String(page ? page + 1 : '');

  if (pageValueForParam) {
    searchParams.set(tableId, pageValueForParam);
  } else if (initialSearchParamsSize) {
    searchParams.delete(tableId);
  } else {
    return;
  }

  history.push({
    pathname: location.pathname,
    search: `?${searchParams.toString()}`,
  });
};
